import './styles.scss';
import { setCookie } from 'typescript-cookie';
import { ProductComponentLibraryOrchestration } from './product-component-library/product-component-library';
import { USIntermediaryUrlLoadOrchestration } from './utilities/url-load/url-load.us-intermediary';
import { FootnoteIndicatorOrchestration } from './utilities/disclaimers/footnote-indicator';
import { BeaconOrchestration } from './beacon/beacon';
import { Constants, Defaults } from './common/constants';
import { Attestation } from './attestation/attestation';

// Set the defaults for the window configuration if they are not already set
window[Constants.POP_CONFIGURATION] = window[Constants.POP_CONFIGURATION] || {
  assetsDomain: Defaults.ASSETS_DOMAIN,
  dadaEndpoint: Defaults.DADA_ENDPOINT,
  dadaApiKey: Defaults.DADA_APIKEY,
  ivsEndpoint: Defaults.IVS_ENDPOINT,
  ivsApiKey: Defaults.IVS_APIKEY,
  dsUiLibraryVersion: Defaults.DS_UI_LIBRARY_VERSION,
  productComponentLibraryVersion: Defaults.PRODUCT_COMPONENT_LIBRARY_VERSION,
  beaconVersion: Defaults.BEACON_VERSION,
  beaconProjectName: Defaults.BEACON_PROJECT_NAME,
  beaconSkip: Defaults.BEACON_SKIP,
  popSkip: Defaults.POP_SKIP,
  country: Defaults.COUNTRY,
  language: Defaults.LANGUAGE,
};

const footnoteIndicatorOrchestration = new FootnoteIndicatorOrchestration();
footnoteIndicatorOrchestration.loadFootnoteIndicatorService();

const productComponentLibraryOrchestration =
  new ProductComponentLibraryOrchestration();
productComponentLibraryOrchestration.loadProductComponentLibrary();

const usIntermediaryUrlLoadOrchestration =
  new USIntermediaryUrlLoadOrchestration();
usIntermediaryUrlLoadOrchestration.createCallback();

const beaconOrchestration = new BeaconOrchestration();
beaconOrchestration.loadBeacon();

/**
 * Come back to this and change to use Context
 */
const dsContextData = window['_ds_contextData'];
if (dsContextData) {
  setCookie('trp-country', dsContextData.country, {
    domain: '.troweprice.com',
    expires: 365,
    path: '/',
  });
}

const applyAustralianSettings = window.location.pathname.includes(
  Constants.AUSTRALIAN_COUNTRY_CODE,
);

if (applyAustralianSettings) {
  if (window.location.href.indexOf('financial-intermediary/au') !== -1) {
    const attestation = new Attestation();
    attestation.generateAttestation();
  }
}
